import { MediaQuerySize } from 'src/constants';
import { useMatchMedia } from './useMatchMedia';

export const isMediaWidth = (size: MediaQuerySize, range: 'min' | 'max' = 'min'): boolean =>
  useMatchMedia(`only screen and (${range}-width: ${size}px)`);
